import { ExportCheckboxesState } from '../hooks/useExportCheckboxes';

export interface BuildRequestOptions {
  selectedRequest: any;
  operationDetails: any;
  checkboxes: ExportCheckboxesState;
  documentsToApply?: any;
  isSimulation?: boolean;
}

export const buildSelectedRequest = (options: BuildRequestOptions) => {
  const {
    selectedRequest,
    operationDetails,
    checkboxes,
    documentsToApply,
    isSimulation = false,
  } = options;

  const documentsApplied = selectedRequest.quoteActive
    ? selectedRequest.quoteActive.documentsToApply
    : documentsToApply || [];

  const cleanedDocuments = isSimulation
    ? selectedRequest.documents.map((doc: any) => ({
        ...doc,
        stakeholderName: undefined,
        reclamo: undefined,
        notaCredito: undefined,
      }))
    : selectedRequest.documents;

  const {
    operationAmount,
    operationCostComissionFixed,
    operationCostComissionVariable,
    operationToDepost,
    operationIva,
    expensesIva,
    operationAmountToApply,
    expensesCost,
    arrearRate,
    advance,
    rate,
    fundRate,
    spread,
    expensesDetails,
    guaranteeAmount,
    guaranteeObservation,
  } = operationDetails;

  return {
    id: selectedRequest.id,
    executiveName: selectedRequest.executiveName,
    businessIdentifier: selectedRequest.businessIdentifier,
    subProductName: selectedRequest.subProductName,
    advance,
    amount: operationAmount,
    businessName: selectedRequest.businessName,
    createdAt: new Date(),
    operationDate: selectedRequest.operationDate || selectedRequest.requestDate,
    financingAt: selectedRequest.financingAt,
    rate,
    arrearRate: arrearRate || selectedRequest.arrearRate,
    amountToApply: operationAmountToApply,
    expenses: expensesCost,
    amountToDepositTotal: operationToDepost,
    documentsToApply: documentsApplied,
    documents: cleanedDocuments,
    operationCostFixed: operationCostComissionFixed,
    operationCostVariable: operationCostComissionVariable,
    operationCostIva: operationIva,
    expensesCostIva: expensesIva,
    expensesDetails,
    guaranteeAmount,
    ...(fundRate !== undefined && { fundRate }),
    ...(spread !== undefined && { spread }),
    ...(guaranteeObservation !== undefined && { guaranteeObservation }),
    ...(isSimulation && { isSimulation }),
    expensesHasIVA: expensesIva > 0 || selectedRequest.expensesIVA || false,
    ...checkboxes,
    // Incluir mensajes del chat seleccionados solo si showChatAsObservations es true
    ...(checkboxes.showChatAsObservations &&
      checkboxes.selectedChatMessagesObjects.length > 0 && {
        selectedChatMessages: checkboxes.selectedChatMessagesObjects,
      }),
  };
};
